// extracted by mini-css-extract-plugin
export default {"diagram-table-header":"DiagramTableHeader_diagram-table-header__f0BsL","diagram-table-header-detail":"DiagramTableHeader_diagram-table-header-detail__JIRWU"};